import {Box, Button, Flex, Text} from '@chakra-ui/react'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'

const SubTitle = () => {
  const {currentQuestion, isOpenSubTitle, currentTimeAudio} = useSelector(
    (state: any) => state.revise,
  )
  const [isOpen, setIsOpen] = useState<any>(false)

  useEffect(() => {
    setIsOpen(false)
  }, [currentQuestion])

  function triggerCustomEvent(time: number) {
    const customEvent = new CustomEvent('myCustomEvent', {
      detail: time,
    })
    const audioWrapElement = document.querySelector(
      '.video-custom-revise',
    ) as HTMLElement
    audioWrapElement.dispatchEvent(customEvent)
  }

  return (
    <>
      {!isOpen && (
        <Flex
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          gap={'16px'}>
          <Text fontSize={'16px'} color={'#8C8C8C'}>
            Nghe hết một lần để mở phụ đề
          </Text>
          <Button
            isDisabled={!isOpenSubTitle}
            fontSize={'16px'}
            fontWeight={700}
            color={'#8C8C8C'}
            w={'fit-content'}
            border={'1px solid #D9D9D9'}
            borderRadius={'12px'}
            bg={'white'}
            onClick={() => setIsOpen(true)}>
            Bật phụ đề
          </Button>
        </Flex>
      )}
      {isOpen && (
        <Box>
          <Text
            fontSize={'13px'}
            fontWeight={600}
            align={'center'}
            color={'#8C8C8C'}
            textTransform={'uppercase'}>
            Phụ đề
          </Text>
          <Box
            className="scroll-bar"
            px={'24px'}
            pb={'24px'}
            mt={'8px'}
            h={'250px'}
            overflow={'auto'}>
            {currentQuestion.data.timeline.map((item: any, index: any) => {
              return (
                <Flex
                  key={index}
                  cursor={'pointer'}
                  fontSize={'13px'}
                  color={
                    currentTimeAudio >= item.start_time &&
                    currentTimeAudio < item.end_time
                      ? '#0050B3'
                      : 'unset'
                  }
                  mt={'8px'}
                  onClick={() => triggerCustomEvent(item.start_time)}>
                  <TimeDisplay totalSeconds={item.start_time} />
                  <Text mr={'8px'} fontWeight={600} w={'45px'}>
                    {item.character_name}
                  </Text>
                  <Text flex={1}>{item.transcript || ''}</Text>
                </Flex>
              )
            })}
          </Box>
        </Box>
      )}
    </>
  )
}

const TimeDisplay = ({totalSeconds}: {totalSeconds: any}) => {
  const minutes = Math.floor(totalSeconds.toFixed(0) / 60)
  const seconds = totalSeconds.toFixed(0) % 60

  return (
    <Text
      mr={'16px'}
      textDecoration={'underline'}
      fontSize={'12px'}
      fontWeight={500}
      style={{
        textWrap: 'nowrap',
      }}>
      {minutes < 10 ? `0${minutes}` : minutes}:
      {seconds < 10 ? `0${seconds}` : seconds}
    </Text>
  )
}

export default SubTitle
